








import { defineComponent } from '@nuxtjs/composition-api'
// import { pageSizes } from '~/common/constants/datasheet'

export default defineComponent({
  props: {
    productId: {
      type: String,
      required: true,
    },
    size: {
      type: String as () => 'a4' | 'letter',
      required: true,
    },
  },
  setup() {
    return {
      print: () => window.print(),
      // download: () => {
      //   const pdfWidth = pageSizes[props.size].width + 'in'
      //   const pdfHeight = pageSizes[props.size].height + 'in'
      //   const url = window.location.href
      //   window.open(
      //     '//pdfcrowd.com/url_to_pdf/' +
      //       `?width=${pdfWidth}` +
      //       `&height=${pdfHeight}` +
      //       '&use_print_media=1' +
      //       `&pdf_name=datasheet-${props.productId}` +
      //       `&hmargin=0` + // Margins are applied using CSS (@page at-rule)
      //       `&wmargin=0` + // Margins are applied using CSS (@page at-rule)
      //       `&url=${encodeURIComponent(url)}`,
      //     '_self'
      //   )
      // },
    }
  },
})
